import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Form, Grid } from 'semantic-ui-react';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../../HelperMethods/FormUtils';
import { PICKLIST_OPTIONS } from './lib/constants';

export default function AssetLevelInfoComponent({ task, attributeObj, formik, ...props }) {
  const { items: assetLevelsOptions = [], isLoading = false } =
    useSelector((state) => state.manageTaskFormReducer[PICKLIST_OPTIONS.ASSET_LEVELS_OPTIONS]) || {};
  const { levelsDetails = [], identifierKey } = props?.settings?.admin?.assetHierarchy ?? {};
  const assetlevelsFormVal = formik?.values?.s_assetlevelsinfo ?? [];

  const attributeOnChange = (event, data) => {
    const assetLevelsFormValue = _.cloneDeep(formik?.values?.s_assetlevelsinfo);
    const updatedLevelValue = { ...assetLevelsFormValue, [data.name]: data.value };
    let levelFound = false;
    for (const [index, { name, identifierValue }] of levelsDetails.entries()) {
      if (levelFound) {
        let options = assetLevelsOptions.filter((option) => option?.originalobject?.level === identifierValue);
        if (index > 0 && updatedLevelValue?.[levelsDetails?.[index - 1]?.name]) {
          options = options.filter(
            (option) => updatedLevelValue[levelsDetails[index - 1].name] === option.originalobject.parentId
          );
        }
        if (options?.length === 1) {
          updatedLevelValue[name] = options[0].value;
        } else {
          updatedLevelValue[name] = '';
        }
      }
      if (name === data.name) {
        levelFound = true;
      }
    }
    formik.setFieldValue(attributeObj.attributeName, updatedLevelValue);
  };

  return levelsDetails.map((level, index) => {
    let options = assetLevelsOptions.filter(
      (option) => option?.originalobject?.[identifierKey] === level.identifierValue
    );
    if (index > 0 && assetlevelsFormVal?.[levelsDetails?.[index - 1]?.name]) {
      options = options.filter(
        (option) => assetlevelsFormVal[levelsDetails[index - 1].name] === option.originalobject.parentId
      );
    }
    return (
      <Grid.Column width={task.id ? 8 : 6} style={{ marginBottom: '10px' }} key={level.name}>
        <Form.Field>
          <>
            <label>{level.displayName}</label>
            {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.PICKLIST]({
              name: level.name,
              value: assetlevelsFormVal?.[level.name],
              options: { items: options, isLoading },
              placeholder: level.displayName,
              onChange: attributeOnChange,
              disabled: index > 0 ? !assetlevelsFormVal?.[levelsDetails?.[index - 1]?.name] : false,
              isLoading,
            })}
          </>
        </Form.Field>
      </Grid.Column>
    );
  });
}
